/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import { Button } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import styles from "./ErrorPage.module.css";
import noappsimage from "../../assets/images/noapps.png";
import { useLocation } from "react-router-dom";
import { getConfig } from "../../config";

const VWLogo = () => (
  <svg
    width="300"
    height="25"
    viewBox="0 0 300 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.4269 19.7366L5.16686 14.7584H2.73925V19.7366H-7.62939e-06V5.09715H5.03973C8.32438 5.09715 10.3911 7.10239 10.3911 10.0098C10.3911 12.0396 9.38646 13.5446 7.67238 14.2745L11.3302 19.7325H8.4228L8.4269 19.7366ZM2.73925 12.3964H4.89211C6.54469 12.3964 7.65187 11.6869 7.65187 10.0139C7.65187 8.34079 6.54469 7.63137 4.89211 7.63137H2.73925V12.4005V12.3964ZM22.3323 17.2065V19.7366H13.2165V5.09715H22.1437V7.62727H15.9558V11.1416H20.6592V13.6102H15.9558V17.2065H22.3323ZM34.212 16.9153H27.3311L26.1788 19.7366H23.2714L29.4183 5.09715H32.1166L38.284 19.7366H35.3561L34.2038 16.9153H34.212ZM33.2894 14.6558L30.7797 8.46792L28.2496 14.6558H33.2894ZM52.3862 12.3554C52.3862 16.4971 49.1672 19.7366 44.9845 19.7366H39.9653V5.09715H44.9845C49.1672 5.09715 52.3862 8.33669 52.3862 12.3513V12.3554ZM49.6019 12.3554C49.6019 9.84575 47.9288 7.69288 44.9599 7.69288H42.7004V17.145H44.9599C47.9288 17.145 49.6019 14.9921 49.6019 12.3554ZM60.7721 13.7783V19.7366H58.0329V13.7783L52.4929 5.10125H55.5889L59.3943 11.2072L63.1998 5.10125H66.3163L60.7762 13.7783H60.7721Z"
      fill="#003865"
    />
    <path
      d="M115.358 12.2897C115.358 13.7086 114.206 14.8609 112.787 14.8609C111.368 14.8609 110.216 13.7086 110.216 12.2897C110.216 10.8709 111.368 9.7186 112.787 9.7186C114.206 9.7186 115.358 10.8709 115.358 12.2897ZM84.0164 10.8709C84.1394 8.42279 86.6286 7.14337 87.9285 7.14337C89.6467 7.14337 91.4797 8.24646 91.4797 11.3466V19.6095H94.2025V11.1046C94.2025 6.37245 91.5289 4.69937 89.2366 4.69937C86.4112 4.69937 84.205 6.97525 84.0164 7.57805V4.97002H81.2936V19.6095H84.0164V10.8709ZM69.9675 0.00408317V19.6136H72.6821V0.00408317H69.9675ZM75.6387 4.97411V19.6136H78.3534V4.97411H75.6387ZM75.6387 0.00408317V2.75564H78.3534V0.00408317H75.6387ZM103.003 11.5639L108.875 4.97002H105.594L99.7917 11.5803V-1.52588e-05H97.1591V19.6095H99.7917V15.1889L101.301 13.483L106.833 19.6095H110.052L103.003 11.5639ZM226.999 0.00408317V19.6136H229.714V0.00408317H226.999ZM178.693 11.5639L184.565 4.97002H181.285L175.482 11.5803V-1.52588e-05H172.85V19.6095H175.482V15.1889L176.991 13.483L182.523 19.6095H185.742L178.693 11.5639ZM255.154 17.4033C252.956 17.4033 250.623 15.6195 250.623 12.3184C250.623 9.01739 252.961 7.17208 255.154 7.17208C256.93 7.17208 257.926 7.9102 258.689 8.77135L260.694 7.76668C259.456 5.76145 257.541 4.70347 255.13 4.70347C252.173 4.70347 248.007 7.06546 248.007 12.3225C248.007 17.5796 252.173 19.8801 255.13 19.8801C257.537 19.8801 259.468 18.8344 260.744 16.8456L258.697 15.8368C257.943 16.6816 256.959 17.4074 255.163 17.4074L255.154 17.4033ZM164.587 8.40639V4.97411H161.839V19.6136H164.587V13.1058C164.886 9.78422 167.211 7.46323 170.242 7.46323C170.377 7.46323 170.533 7.46323 170.701 7.47143V4.71577C170.524 4.70347 170.34 4.70347 170.127 4.70347C167.859 4.70347 165.206 6.04439 164.583 8.40639H164.587ZM204.519 0.963645H201.78V4.97002H199.725V7.23769H201.78V16.2715C201.78 18.8303 202.813 19.876 205.343 19.876C206.426 19.876 207.193 19.6382 207.644 19.4372V17.186C207.254 17.2885 206.832 17.3664 206.356 17.3664C205.138 17.3664 204.519 16.7144 204.519 15.4309V7.24179H207.644V4.97411H204.519V0.967743V0.963645ZM138.076 4.70347C137.309 4.70347 136.058 4.888 134.771 5.71634C133.524 6.52007 132.228 7.96761 131.999 8.24646H131.826C130.986 5.67943 129.009 4.70347 127.258 4.70347C124.42 4.70347 122.202 6.97935 122.017 7.58215V4.97411H119.282V19.6136H122.017V10.8791C122.14 8.43099 124.642 7.15158 125.946 7.15158C127.668 7.15158 129.509 8.25466 129.509 11.3548V19.6177H132.835V10.8832C132.958 8.43509 135.46 7.15568 136.764 7.15568C138.486 7.15568 140.327 8.25876 140.327 11.3589V19.6218H143.062V11.121C143.062 6.38885 140.376 4.71577 138.076 4.71577V4.70347ZM224.793 12.2938C224.793 17.2229 221.324 19.876 218.06 19.876C215.739 19.876 213.426 18.4613 212.983 17.6698V24.8337H210.268V4.97002H212.983V7.03266L213.02 6.95884C213.397 6.17971 215.698 4.69937 218.064 4.69937C219.696 4.69937 221.336 5.38418 222.57 6.56518C223.587 7.54114 224.797 9.32494 224.797 12.2938H224.793ZM222.164 12.2938C222.164 9.75962 220.582 7.19259 217.559 7.19259C215.242 7.19259 212.901 8.94358 212.901 12.2938C212.901 15.6441 215.247 17.3951 217.559 17.3951C220.582 17.3951 222.164 14.8281 222.164 12.2938ZM198.717 13.2247H187.719L187.838 13.7906C188.33 16.1485 190.064 17.555 192.471 17.555C194.267 17.555 195.198 17.1203 196.178 16.4847L197.601 17.961C196.301 19.265 194.624 19.876 192.365 19.876C190.56 19.876 188.768 19.1871 187.452 17.9897C186.394 17.0219 185.131 15.2545 185.131 12.3184C185.131 7.06546 189.215 4.69937 192.115 4.69937C193.595 4.69937 195.694 5.32677 197.146 7.09417C198.401 8.61962 198.946 10.7356 198.725 13.2247H198.717ZM196.408 11.3507L196.33 10.8135C195.949 8.23006 193.874 7.05316 192.11 7.05316C190.347 7.05316 188.444 8.20546 187.87 10.7807L187.743 11.3548H196.412L196.408 11.3507ZM275.576 13.2247H264.578L264.697 13.7906C265.189 16.1485 266.923 17.555 269.33 17.555C271.127 17.555 272.057 17.1203 273.037 16.4847L274.46 17.961C273.16 19.265 271.483 19.876 269.224 19.876C267.42 19.876 265.628 19.1871 264.311 17.9897C263.253 17.0219 261.99 15.2545 261.99 12.3184C261.99 7.06546 266.075 4.69937 268.974 4.69937C270.454 4.69937 272.554 5.32677 274.005 7.09417C275.26 8.61962 275.805 10.7356 275.584 13.2247H275.576ZM273.263 11.3507L273.185 10.8135C272.804 8.23006 270.729 7.05316 268.966 7.05316C267.202 7.05316 265.299 8.20546 264.725 10.7807L264.598 11.3548H273.267L273.263 11.3507ZM156.717 4.97411H159.428V19.6136H156.717V17.5509L156.681 17.6247C156.303 18.4039 154.003 19.8801 151.637 19.8801C148.373 19.8801 144.903 17.2229 144.903 12.2938C144.903 9.32494 146.113 7.54114 147.13 6.56518C148.364 5.38418 150.005 4.70347 151.637 4.70347C153.958 4.70347 156.275 6.1223 156.717 6.91374V4.97411ZM156.804 12.2897C156.804 8.93948 154.458 7.18438 152.141 7.18438C149.119 7.18438 147.536 9.75141 147.536 12.2897C147.536 14.8281 149.119 17.3951 152.141 17.3951C154.458 17.3951 156.804 15.64 156.804 12.2897ZM156.717 4.97411H159.428V19.6136H156.717V17.5509L156.681 17.6247C156.303 18.4039 154.003 19.8801 151.637 19.8801C148.373 19.8801 144.903 17.2229 144.903 12.2938C144.903 9.32494 146.113 7.54114 147.13 6.56518C148.364 5.38418 150.005 4.70347 151.637 4.70347C153.958 4.70347 156.275 6.1223 156.717 6.91374V4.97411ZM156.804 12.2897C156.804 8.93948 154.458 7.18438 152.141 7.18438C149.119 7.18438 147.536 9.75141 147.536 12.2897C147.536 14.8281 149.119 17.3951 152.141 17.3951C154.458 17.3951 156.804 15.64 156.804 12.2897ZM243.41 4.97411H246.121V19.6136H243.41V17.5509L243.373 17.6247C242.996 18.4039 240.695 19.8801 238.329 19.8801C235.065 19.8801 231.596 17.2229 231.596 12.2938C231.596 9.32494 232.806 7.54114 233.823 6.56518C235.057 5.38418 236.697 4.70347 238.329 4.70347C240.65 4.70347 242.967 6.1223 243.41 6.91374V4.97411ZM243.496 12.2897C243.496 8.93948 241.151 7.18438 238.834 7.18438C235.811 7.18438 234.229 9.75141 234.229 12.2897C234.229 14.8281 235.811 17.3951 238.834 17.3951C241.151 17.3951 243.496 15.64 243.496 12.2897Z"
      fill="#0082FF"
    />
    <path
      d="M297.15 17.0752C296.719 17.0752 296.309 17.1737 295.94 17.3459L294.169 15.5744V9.25933L295.94 7.48784C296.309 7.66007 296.715 7.75848 297.15 7.75848C298.725 7.75848 300 6.48317 300 4.90851C300 3.33384 298.725 2.05853 297.15 2.05853C295.575 2.05853 294.3 3.33384 294.3 4.90851C294.3 5.33908 294.398 5.74915 294.571 6.11821L292.799 7.88971H286.484L284.713 6.11821C284.885 5.74915 284.983 5.34318 284.983 4.90851C284.983 3.33384 283.708 2.05853 282.133 2.05853C280.559 2.05853 279.283 3.33384 279.283 4.90851C279.283 6.48317 280.559 7.75848 282.133 7.75848C282.564 7.75848 282.974 7.66007 283.343 7.48784L285.115 9.25933V15.5744L283.343 17.3459C282.974 17.1737 282.568 17.0752 282.133 17.0752C280.559 17.0752 279.283 18.3506 279.283 19.9252C279.283 21.4999 280.559 22.7752 282.133 22.7752C283.708 22.7752 284.983 21.4999 284.983 19.9252C284.983 19.4946 284.885 19.0846 284.713 18.7155L286.484 16.944H292.799L294.571 18.7155C294.398 19.0846 294.3 19.4905 294.3 19.9252C294.3 21.4999 295.575 22.7752 297.15 22.7752C298.725 22.7752 300 21.4999 300 19.9252C300 18.3506 298.725 17.0752 297.15 17.0752ZM287.054 9.82933H292.229V15.0044H287.054V9.82933Z"
      fill="url(#paint0_linear_7581_33336)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7581_33336"
        x1="279.279"
        y1="12.421"
        x2="300.004"
        y2="12.421"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0082FF" />
        <stop offset="0.2" stopColor="#007DFC" />
        <stop offset="0.42" stopColor="#006FF5" />
        <stop offset="0.67" stopColor="#0057E9" />
        <stop offset="0.92" stopColor="#0037D9" />
        <stop offset="1" stopColor="#002CD4" />
      </linearGradient>
    </defs>
  </svg>
);

const ErrorPage = () => {
  const invalidUserLogin = true;
  const pendingApprovalUser = true;
  const errorMessageFromLocation = useLocation().state?.errorMessage || "";

  const getPortalConfig = (app_portal) => {
    const portalConfigs = {
      "oem-admin": {
        clientId: getConfig().REACT_APP_OEM_ADMIN_CLIENT_ID,
        vwClientId: getConfig().REACT_APP_VW_OEM_ADMIN_CLIENT_ID,
        scopeId: "rs%2FigniteStorePortfolioManager%20openid%20aws.cognito.signin.user.admin",
      },
      seller: {
        clientId: getConfig().REACT_APP_CLIENT_ID,
        vwClientId: getConfig().REACT_APP_VW_CLIENT_ID,
        scopeId: "rs%2FigniteStoreSeller%20openid%20aws.cognito.signin.user.admin",
      },
      "domain-approver": {
        clientId: getConfig().REACT_APP_DOMAIN_APPROVER_CLIENT_ID,
        vwClientId: getConfig().REACT_APP_VW_DOMAIN_APPROVER_CLIENT_ID,
        scopeId: "rs%2FigniteStoreDomainApprover%20openid%20aws.cognito.signin.user.admin",
      },
      "global-admin": {
        clientId: getConfig().REACT_APP_GLOBAL_ADMIN_CLIENT_ID,
        vwClientId: "",
        scopeId: "rs%2FigniteStoreAdmin%20openid%20aws.cognito.signin.user.admin",
      },
    };

    return portalConfigs[app_portal] || { clientId: "", vwClientId: "", scopeId: "" };
  };

  const handleLogout = async () => {
    const app_portal = getConfig().REACT_APP_PORTAL;
    const { clientId, vwClientId: vw_client_id, scopeId } = getPortalConfig(app_portal);

    if (
      sessionStorage.getItem("idpLogin") &&
      sessionStorage.getItem("idpLogin") === "false"
    ) {
      const cognitoDomain = getConfig().REACT_APP_COGNITO_DOMAIN;
      const redirect_uri = getConfig().REACT_APP_REDIRECT_URI;
      const logoutUrl = `${cognitoDomain}/logout?client_id=${clientId}&response_type=code&scope=${scopeId}&redirect_uri=${redirect_uri}&portal=${app_portal}`;
      sessionStorage.clear();
      globalThis.location.href = logoutUrl;
      sessionStorage.clear();
    } else {
      const revokeURL = `${getConfig().REACT_APP_COGNITO_DOMAIN}/oauth2/revoke`;
      try {
        const body = new URLSearchParams();
        body.set("token", sessionStorage.getItem("refresh_token"));
        body.set("client_id", vw_client_id);

        const response = await fetch(revokeURL, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: body.toString(),
        });
        if (response.ok) {
          const redirect_uri = getConfig().REACT_APP_REDIRECT_URI;
          const logoutUrl = `${
            getConfig().REACT_APP_VW_LOGOUT_URL
          }${sessionStorage.getItem(
            "IDP_TOKEN"
          )}&post_logout_redirect_uri=${redirect_uri}&state=logout_state_1`;
          sessionStorage.clear();
          sessionStorage.setItem("idpLogout", true);
          globalThis.location.href = logoutUrl;
        }
      } catch (error) {
        console.error("Error during logout:", error);
      }
    }
  };

  return (
    <>
      {(invalidUserLogin || pendingApprovalUser) && (
        <div className={styles.noReadyLinkMarketPlace}>
          <VWLogo />

          <img
            className={styles.noAppsImagecls}
            src={noappsimage}
            alt="no apps img"
          />
          {invalidUserLogin && (
            <div className={styles.noAppsWelcomeTextcls}>401 Error</div>
          )}
          {invalidUserLogin && (
            <div className={styles.unauthorizedLogin}>Unauthorized Login</div>
          )}
          {invalidUserLogin && (
            <div className={styles.inavlidUserLoginMessage}>
              {errorMessageFromLocation
                || "Invalid user trying to login"}
            </div>
          )}

          <Button
            style={{
              background: "#121415F2",
              textTransform: "none",
              height: "36px",
              marginTop: "12px",
            }}
            variant="contained"
            onClick={handleLogout}
          >
            <LogoutIcon fontSize="small" /> &nbsp; Logout
          </Button>
        </div>
      )}
    </>
  );
};

export default ErrorPage;
